import React, { useContext } from 'react';
const defaultKoodistos = {
    kunnat: [],
    yritysmuodot: [],
    organisaatiotyypit: [],
    posti: [],
    postinumerot: [],
};
export const KoodistoContext = React.createContext(defaultKoodistos);
export const useKoodistos = () => {
    const context = useContext(KoodistoContext);
    if (!context && context !== null) {
        throw new Error('Koodisto not available');
    }
    return context;
};
